import { render, staticRenderFns } from "./temperature.vue?vue&type=template&id=9e885a5c&"
import script from "./temperature.vue?vue&type=script&lang=js&"
export * from "./temperature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports